import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./KeepReadingSection.css";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

const GOOGLE_SHEET_API_URL =
  "https://script.google.com/macros/s/AKfycbzNePVdb8kwFqV381MKbgR7I5GZKH5Gg9nF_ypfCgizYYMouNsMpWa8eku_MuVcqWIJgA/exec";
export default function KeepReadingSection({ currentBlogId }) {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    fetch(GOOGLE_SHEET_API_URL)
      .then((res) => res.json())
      .then((data) => {
        // Exclude current blog
        const filtered = data.filter((blog) => blog.id !== currentBlogId);
        // Sort by date (latest first) and take 2
        const latest = filtered
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 2);
        setBlogs(latest);
      })
      .catch((err) => console.error("Error fetching blogs:", err));
  }, [currentBlogId]);
  return (
    <section className="keep-reading-section">
      <h2 className="keep-reading-title">Keep Reading</h2>
      <div className="keep-reading-list">
        {blogs.map((blog) => (
          <Link
            to={`/blogs/${blog.id}`}
            key={blog.id}
            className="keep-reading-item"
          >
            <img
              src={blog.image_url}
              alt={blog.title}
              className="keep-reading-thumb"
            />
            <div className="keep-reading-info">
              <div className="keep-reading-meta">
                {blog.category && (
                  <span className="keep-reading-category">
                    {blog.category}
                  </span>
                )}
                <span className="keep-reading-date">{blog.date}</span>
              </div>
              <h3 className="keep-reading-heading">{blog.title}</h3>
            </div>      
          </Link>
        ))}
      </div>
    </section>
  );
}